module.exports = __webpack_public_path__ + "img/daogou.3d8c762a.png";